import { computed, Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ThemeService {
  readonly #STORAGE_KEY = 'iw-theme';
  readonly #LIGHT_THEME = 'light';
  readonly #DARK_THEME = 'dark';
  readonly #DEFAULT_THEME = 'light';

  readonly #theme = signal<string>(this.#DEFAULT_THEME);

  readonly theme = this.#theme.asReadonly();

  readonly isDarkTheme = computed(() => this.#theme() === this.#DARK_THEME);

  constructor() {
    const storedTheme =
      localStorage.getItem(this.#STORAGE_KEY) || this.#DEFAULT_THEME;
    this.setTheme(storedTheme);

    if (
      storedTheme == null &&
      matchMedia &&
      matchMedia('(prefers-color-scheme: light)').matches
    ) {
      this.setTheme(this.#LIGHT_THEME);
    } else {
      this.setTheme(storedTheme || this.#DEFAULT_THEME);
    }
  }

  toggleTheme(): void {
    if (this.isDarkTheme()) {
      this.setTheme(this.#LIGHT_THEME);
    } else {
      this.setTheme(this.#DARK_THEME);
    }
  }

  setTheme(theme: string): void {
    this.#theme.set(theme);
    document.documentElement.className = theme;
    localStorage.setItem(this.#STORAGE_KEY, this.#theme());
  }
}
